import React, { useState, useEffect } from "react";
import { FaGooglePlay } from "react-icons/fa";

const AppNotificationBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if the user was already notified / dismissed
    const alreadyNotified = localStorage.getItem("gj_app_notified");
    if (!alreadyNotified) {
      // Show notification after a brief delay (1 second) so it feels smooth
      const timer = setTimeout(() => {
        setVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("gj_app_notified", "true");
    setVisible(false);
  };

  const handleDownload = () => {
    localStorage.setItem("gj_app_notified", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes gjSlideUp {
          from {
            opacity: 0;
            transform: translate(-50%, 25px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .gj-app-banner-card {
          position: fixed;
          bottom: 18px;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 28px);
          max-width: 480px;
          background: linear-gradient(135deg, #0e1217 0%, #171d26 100%);
          border: 1.5px solid #f5d76e;
          border-radius: 14px;
          box-shadow: 0 12px 35px rgba(0, 0, 0, 0.75), 0 0 20px rgba(245, 215, 110, 0.25);
          padding: 10px 14px;
          z-index: 99999;
          display: flex;
          align-items: center;
          gap: 12px;
          animation: gjSlideUp 0.35s ease-out forwards;
          font-family: inherit;
        }
        .gj-app-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #48ff91;
          color: #000;
          font-weight: 700;
          font-size: 0.82rem;
          padding: 8px 14px;
          border-radius: 8px;
          text-decoration: none;
          flex-shrink: 0;
          box-shadow: 0 2px 10px rgba(72, 255, 145, 0.35);
          transition: transform 0.15s ease, background 0.15s ease;
        }
        .gj-app-btn:hover {
          background: #39e680;
          transform: scale(1.03);
        }
        .gj-app-close {
          background: transparent;
          border: none;
          color: #94a3b8;
          font-size: 1.25rem;
          cursor: pointer;
          padding: 4px;
          line-height: 1;
          flex-shrink: 0;
          transition: color 0.15s ease;
        }
        .gj-app-close:hover {
          color: #fff;
        }
      `}</style>

      <div className="gj-app-banner-card" role="alert">
        {/* App Icon */}
        <img
          src="/assets/logo.jpeg"
          alt="GJ Bullion Logo"
          style={{
            width: "44px",
            height: "44px",
            borderRadius: "10px",
            objectFit: "cover",
            flexShrink: 0,
            border: "1px solid rgba(245, 215, 110, 0.4)",
          }}
        />

        {/* Text Details */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.92rem",
              lineHeight: 1.2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            GJ Bullion Official App
          </div>
          <p
            style={{
              margin: "3px 0 0 0",
              color: "#cbd5e1",
              fontSize: "0.78rem",
              lineHeight: 1.2,
            }}
          >
            Live Indore bullion rates & instant trading on Android
          </p>
        </div>

        {/* Action Button */}
        <a
          href="https://play.google.com/store/apps/details?id=com.gjbullion.app&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
          className="gj-app-btn"
          onClick={handleDownload}
          title="Download GJ Bullion on Google Play"
        >
          <FaGooglePlay size={13} />
          <span>Get App</span>
        </a>

        {/* Dismiss Button */}
        <button
          className="gj-app-close"
          onClick={handleDismiss}
          aria-label="Close notification"
          title="Dismiss"
        >
          ✕
        </button>
      </div>
    </>
  );
};

export default AppNotificationBanner;
